import { createContext, useContext } from "react";
import { ProblemDetails } from "./ProblemDetails";

interface ProblemDetailsContextProps {
  problem: ProblemDetails | null;
  setProblem: (problem: ProblemDetails | null) => void;
}

export const ProblemDetailsContext = createContext<ProblemDetailsContextProps | undefined>(undefined);

export const useProblemDetails = (): ProblemDetailsContextProps => {
  const context = useContext(ProblemDetailsContext);
  if (!context) {
    throw new Error('useProblemDetails must be used within a ProblemDetailsProvider');
  }
  return context;
};